export const calculateAnchorOfBounds = (bounds, anchorType) => {
    const {x1: x1, x2: x2, y1: y1, y2: y2} = bounds, rectWidth = Math.abs(x2 - x1), rectHeight = Math.abs(y2 - y1);
    let anchorX = (x1 + x2) / 2, anchorY = (y1 + y2) / 2, sx = 0, sy = 0;
    switch (anchorType) {
      case "top":
      case "inside-top":
        sy = -.5;
        break;

      case "bottom":
      case "inside-bottom":
        sy = .5;
        break;

      case "left":
      case "inside-left":
        sx = -.5;
        break;

      case "right":
      case "inside-right":
        sx = .5;
        break;

      case "top-right":
        sx = .5, sy = -.5;
        break;

      case "top-left":
        sx = -.5, sy = -.5;
        break;

      case "bottom-right":
        sx = .5, sy = .5;
        break;

      case "bottom-left":
        sx = -.5, sy = .5;
    }
    return anchorX += sx * rectWidth, anchorY += sy * rectHeight, {
        x: anchorX,
        y: anchorY
    };
};
//# sourceMappingURL=bounds-util.js.map
